module.exports = __webpack_public_path__ + "img/ad_datong.679f5155.png";